import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchAmountTotals = (year = {}) =>
  apiActionCreator({
    'endpoint': '/orders/providers/amount-control',
    'authenticated': true,
    'types': [
      ActionTypes.GET_AMOUNT_TOTALS,
      ActionTypes.GET_AMOUNT_TOTALS_SUCCESS,
      [
        ActionTypes.GET_AMOUNT_TOTALS_ERROR,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': year,
  });
